import Axios from 'axios';
import Qs from 'qs';
import { Loading, Message } from 'element-ui';
import router from "@/router";

class MyAxios {
	baseUrl = '/venus';
	currentLoading = null; // 当前loading实例
	loadingOption = {
		text: '加载中……',
		background: 'rgba(0, 0, 0, 0.5)'
	};
	constructor() {
		this.axios = Axios.create({
			baseURL: this.baseUrl,
			timeout: 10000,
			withCredentials: true,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/json',
				'Accept': 'application/json, text/plain, */*'
			}
		});
		this.interceptorsRequst();
		this.interceptorsResponse();
	}

	// 请求拦截器
	interceptorsRequst() {
		this.axios.interceptors.request.use((request) => {
			switch (request.url) {
				case '/login':
					request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
					request.data = Qs.stringify(request.data);
					break;
			}
			return request;
		})
	}

	// 响应拦截器
	interceptorsResponse() {
		this.axios.interceptors.response.use((response) => {
			return response.data;
		}, (err) => {
			try {
				if (err.response.data.message) {
					if (err.response.data.code == 100002) {
						router.push('/');
					}
					Message({
						message: err.response.data.message,
						type: 'error'
					});
				} else {
					Message({
						message: err.response.data,
						type: 'error'
					});
				}
			} catch {
				Message({
					message: '网络异常',
					type: 'error'
				});
			}
		})
	}

	// loading处理
	async loadingDeal(showLoading, hideLoading, cb, requestsLength = 0) {
		switch (true) {
			case showLoading === true:
				this.currentLoading = Loading.service(this.loadingOption);
				break;
			case typeof showLoading === 'string':
				this.currentLoading = Loading.service({
					...this.loadingOption,
					text: showLoading
				});
				break;
			case typeof showLoading === 'object':
				this.currentLoading = Loading.service({
					...this.loadingOption,
					...showLoading
				});
				break;
		}
		let result = await cb(); // 等待请求完毕
		// console.log('await:', result)
		if (showLoading) { // 只有当showLoading存在时才关闭loading
			if (hideLoading) {
				this.currentLoading.close();
			}
			if (result) { // 当接口有返回值时
				switch (true) {
					case typeof hideLoading === 'string':
						Message({
							message: hideLoading,
							type: 'success'
						});
						break;
					case typeof hideLoading === 'object':
						Message({
							...hideLoading
						});
						break;
				}
			}
			// 无返回值的错误回调在响应拦截器里处理
		}
		return new Promise((resolve, reject) => {
			// 请求队列时
			if (requestsLength > 0) {
				// 请求发送数量和成功数量不一致时，catch
				if (result.filter(item => item != undefined).length == requestsLength) {
					resolve(result);
				} else {
					reject();
				}
			// 单请求时
			} else {
				if (result) {
					resolve(result.message);
				} else {
					reject();
				}
			}
		})
	}

	// 合并参数拼接
	concatParams(params) {
		let paramsArray = [];
		for (let key in params) {
			if (params[key] != null) {
				if (Array.isArray(params[key])) {
					params[key].map(item => {
						paramsArray.push(`${key}%5B%5D=${item}`);
					})
				} else {
					paramsArray.push(`${key}=${params[key]}`);
				}
			}
		}
		return (paramsArray.length > 0 ? '?' : '') + paramsArray.join('&'); // 将于拼接在链接后的参数字符串
	}

	// GET
	get(url, params, showLoading = false, hideLoading = true) {
		return this.loadingDeal(showLoading, hideLoading, () => {
			return this.axios.get(url + this.concatParams(params));
		})
	}

	// POST
	post(url, params, showLoading = false, hideLoading = true) {
		return this.loadingDeal(showLoading, hideLoading, () => {
			return this.axios.post(url, params)
		})
	}

	// PUT
	put(url, params, showLoading = false, hideLoading = true) {
		return this.loadingDeal(showLoading, hideLoading, () => {
			return this.axios.put(url + this.concatParams(params))
		})
	}

	// DELETE
	delete(url, params, showLoading = false, hideLoading = true) {
		return this.loadingDeal(showLoading, hideLoading, () => {
			return this.axios.delete(url + this.concatParams(params))
		})
	}

	// ALL
	all(requests, showLoading = false, hideLoading = true) {
		return this.loadingDeal(showLoading, hideLoading, () => {
			return Promise.all(requests)
		}, requests.length)
	}
}

export default new MyAxios();